module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form class="photoInputForm">\n    <div>\n        <label class="photoInputFormLabel photoInputFormLabelPosition" for="file">Ajout de documents</label>  \n        <input class="photoInputFormInput specialFileMask formInput" type="text" placeholder="Parcourir..." disabled>\n        <input class="photoInputFormInput photoInputFormFile formInput" type="file" name="file" multiple>  \n    </div>\n    <div class="pendingFilesHolder">\n    </div>\n</form> ';

}
return __p
}